<template>
  <CommonTabs
    :id="$props.id"
    resource="cost-allocators"
    :tabs="tabs"
    :components="components"
    :default-router="{ name: 'cost-centres' }"
    :breadcrumbs="breadcrumbs"
  ></CommonTabs>
</template>

<script>
import CommonTabs from "../../../components/common/tabs/CommonTabs";
import EditCostAllocator from "../../../components/projects/accounting/cost-allocators/EditCostAllocator";
import NewCostAllocator from "../../../components/projects/accounting/cost-allocators/NewCostAllocator";
import DeleteCostAllocator from "../../../components/projects/accounting/cost-allocators/DeleteCostAllocator";
import { projectTitle } from "../../../components/mixins/projects/projectTitle";

export default {
  name: "CostAllocator",
  mixins: [projectTitle],
  components: {
    CommonTabs
  },
  props: ["project_id", "id"],
  data: () => ({
    components: {
      EditCostAllocator,
      DeleteCostAllocator,
      NewCostAllocator
    }
  }),
  computed: {
    tabs() {
      return this.$props.id
        ? [
            {
              component: "EditCostAllocator",
              title: "edit"
            },
            {
              component: "DeleteCostAllocator",
              title: "delete"
            }
          ]
        : [
            {
              component: "NewCostAllocator",
              title: "new"
            }
          ];
    },
    costAllocator: {
      get() {
        return this.$store.getters[
          "projectAccountingStore/costAllocatorStore/getItem"
        ];
      }
    },
    breadcrumbs() {
      return [
        {
          text: this.$t("cost-centres.cost-centres"),
          to: {
            name: "cost-centres",
            params: {
              project_id: this.project.id
            }
          },
          exact: true
        },
        {
          text: this.$t("cost-allocators.cost-allocators"),
          disabled: true
        },
        ...(this.costAllocator.id
          ? [
              {
                text:
                  this.$t("cost-allocators.providing-cost-centre") +
                  ": " +
                  this.costAllocator._provider.name,
                to: {
                  name: "cost-centre",
                  params: {
                    project_id: this.project.id,
                    id: this.costAllocator._provider.id
                  }
                },
                exact: true
              },
              {
                text:
                  this.$t("cost-allocators.consuming-cost-centre") +
                  ": " +
                  this.costAllocator._consumer.name,
                to: {
                  name: "cost-centre",
                  params: {
                    project_id: this.project.id,
                    id: this.costAllocator._consumer.id
                  }
                },
                exact: true
              }
            ]
          : [])
      ];
    }
  },
  methods: {
    getItem() {
      if (this.$props.id) {
        this.$store.dispatch("projectAccountingStore/costAllocatorStore/get", {
          id: this.$props.id,
          project_id: this.$props.project_id
        });
      }
    },
    getArgumentForTitle() {
      return {
        chain: [
          this.$t("cost-allocators.cost-allocators"),
          this.$props.id
            ? this.$t("cost-allocators.edit")
            : this.$t("cost-allocators.new")
        ]
      };
    }
  },
  watch: {
    $props: {
      handler() {
        this.getItem();
      },
      deep: true,
      immediate: true
    },
    costCenter() {
      this.setTitle();
    }
  },
  mounted() {
    this.getItem();
  }
};
</script>
